import {ChangeDetectionStrategy, Component, Input, OnInit, ViewChild} from '@angular/core';
import {NgxFlickingComponent} from "@egjs/ngx-flicking";
import {Compbaser} from "../../../components/compbaser";
import {StoreSelectorsService} from "../../../services";
import {IAppSettingsWrap, IStationData, IStationStatsV1} from "../../../interfaces";
import {StationSnapshotComponent} from "../../stations/station-snapshot/station-snapshot.component";

@Component({
    selector: 'app-station-slider',
    templateUrl: './station-slider.component.html',
    styleUrls: ['./station-slider.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StationSliderComponent extends Compbaser implements OnInit {

    plugins: Plugin[] = [];
    tabIndex = 0;
    _ready = false;
    m_station: Array<IStationData> = [];
    snapping = false;
    coreAppData: IAppSettingsWrap;

    // @Input() selectedStation: IStation;

    @Input()
    set stations(i_stations: Array<IStationData>) {
        if (i_stations.length === 0) return;
        this.m_station = i_stations;
        setTimeout(() => {
            this._ready = true;
        }, 300);
    }

    @ViewChild(NgxFlickingComponent) flick: NgxFlickingComponent;
    @ViewChild(StationSnapshotComponent) stationSnapshotComponent: StationSnapshotComponent;

    constructor(private storeSelector: StoreSelectorsService) {
        super();
        this.cod(
            this.storeSelector.getCoreData()
                .subscribe((i_coreData: IAppSettingsWrap) => this.coreAppData = i_coreData)
        );
    }

    ngOnInit() {
    }

    onSnap(i_station: IStationData) {
        // let idx = (this.flick as any).getIndex();
        // if (idx === -1) idx = 0;
        // this.stationSnapshotComponent.takeSnapshotUser(i_station, this.coreAppData[0].businessId);
        this.stationSnapshotComponent.takeSnapshotUser(i_station, i_station.stat.$.businessId, null);
        this.snapping = true;
    }

    onSlide(direction, event) {
        this.snapping = false;
        const idx = (this.flick as any).getIndex();
        if (direction === 'prev' && idx === 0) return;
        if (direction === 'next' && idx === this.m_station.length - 1) return;
        if (direction === 'prev') return (this.flick as any).moveTo(idx - 1);
        if (direction === 'next') return (this.flick as any).moveTo(idx + 1);
    }

    onChange(idx: string) {
        // console.log(this.m_station[idx].$.name);
        const station: IStationData = this.m_station[idx];
        if (station?.stat?.$?.businessId) {
            this.onSnap(this.m_station[idx]);
        }
    }
}
